import React, { useEffect, useRef, useState } from "react";
import { toast } from "react-toastify";
import axios from "axios";
import moment from "moment";
import { BsFileEarmarkMedical } from "react-icons/bs";
import { IoChevronDown, IoChevronUp } from "react-icons/io5";
import { useMediaQuery } from "react-responsive";

const Notice = ({ project, projectNotice }) => {
  const projectFeedBodyRef = useRef(null);
  const [noticeHeight, setNoticeHeight] = useState("auto");
  const [isExpanded, setIsExpanded] = useState(true);

  const calcHeight = () => {
    if (projectFeedBodyRef.current) {
      setNoticeHeight(`${projectFeedBodyRef.current.scrollHeight}px`);
    }
  };

  useEffect(() => {
    const images = projectFeedBodyRef.current?.querySelectorAll("img") || [];
    let imagesLoaded = 0;

    const onImageLoad = () => {
      imagesLoaded += 1;
      if (imagesLoaded === images.length) {
        calcHeight();
      }
    };

    if (images.length > 0) {
      images.forEach((img) => {
        if (img.complete) {
          imagesLoaded += 1;
        } else {
          img.addEventListener("load", onImageLoad);
        }
      });

      if (imagesLoaded === images.length) {
        calcHeight();
      }
    } else {
      calcHeight();
    }

    return () => {
      images.forEach((img) => {
        img.removeEventListener("load", onImageLoad);
      });
    };
  }, [projectNotice]);

  const isFileType = {
    I: "이미지",
    V: "비디오",
    F: "파일",
  };

  const handleDownloadFile = async (file) => {
    if (!file || !file?.filePath) return;
    const { filePath: path } = file;

    const absoluteUrl = path.startsWith("http") ? path : `${imgHandler(path)}`;
    const res = await axios.post("/api/getFile", { url: absoluteUrl }, { responseType: "blob" });

    const blob = new Blob([res.data], {
      type: res.headers["content-type"] || "application/octet-stream",
    });

    const blobUrl = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = blobUrl;
    a.download = decodeURIComponent(absoluteUrl.split("/").pop() || "downloaded_file");
    a.click();
    window.URL.revokeObjectURL(blobUrl);
  };

  const toggleHeight = () => {
    if (!isExpanded) {
      calcHeight();
    } else {
      setNoticeHeight("0px");
    }
    setIsExpanded(!isExpanded);
  };

  return (
    <div>
      <div className="projectFeedHeader">
        <div className="writerInfo">
          <img
            src={
              projectNotice?.imgPath
                ? imgHandler(projectNotice.imgPath, false)
                : "/img/logo_with_text.png"
            }
            alt="logo"
            style={{ width: 40, height: 40, objectFit: "contain", borderRadius: "50%" }}
          />
          <div>
            {<span>{project?.mberNm ? project.mberNm : ""}</span>}
            <p>{moment(projectNotice?.updateDt).format("YYYY-MM-DD HH:mm")}</p>
          </div>
        </div>
        <span className="projectInfo">{project?.orgNm}</span>
      </div>
      <div className="projectFeedToggle">
        <button onClick={toggleHeight}>{isExpanded ? <IoChevronUp /> : <IoChevronDown />}</button>
      </div>
      <div
        className="projectFeedBody"
        ref={projectFeedBodyRef}
        style={{
          height: noticeHeight,
          margin: 15,
        }}>
        <div className="tit">{projectNotice?.title}</div>
        <div
          className="con"
          id="contents"
          dangerouslySetInnerHTML={{ __html: projectNotice?.content }}></div>
        <div className="files">
          {projectNotice?.fileList && projectNotice?.fileList?.length > 0 && (
            <ul>
              {projectNotice?.fileList.map((item) => (
                <li onClick={() => handleDownloadFile(item)}>
                  <div className="icon">
                    <BsFileEarmarkMedical />
                  </div>
                  <span>{item.fileNm}</span>
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>
    </div>
  );
};

export default Notice;
